export default __webpack_public_path__ + "static/media/tu-brenda-le.6367cb7f.jpg";